import { unsafeCSS, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { PopBaseComponent } from '../../../../base/pop-base-component.js';
import { Constants } from './chip.constants.js';
import { IconSVG } from '../../../../common/utils/icon.js';
import { Constants as ProductCenterTableWrapperConstants } from '../../../product-center-table-wrapper/product-center-table-wrapper.constants';
import { replacePlaceholders } from '../../../../common/utils/textFormat';

import style from './chip.scss?inline';

/**
 * @tag pop-pc-chip-component
 * @attribute {Chip} [data-component-object] Chip content
 */
@customElement(Constants.TAG_NAME)
export class PopChipComponent extends PopBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }

  static readonly tagName = Constants.TAG_NAME;

  /*
   * Component Methods
   */
  private closeChipHandler() {
    this.dispatchEvent(
      new CustomEvent(Constants.EVENTS.CLOSE_CHIP, {
        detail: {
          categoryField: this.componentObject.categoryField,
          filterValue: this.componentObject.label,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  renderComponent() {
    return html`
      <div id="chip-${this.componentObject.chipId}" class="chip-container">
        <span class="chip-label"> ${this.componentObject.label} </span>
        <beacon-button
          @beacon-event-click=${this.closeChipHandler}
          class="close-chip"
          variant="tertiary"
          scale="normal"
        >
          ${IconSVG.close({
            slot: ProductCenterTableWrapperConstants.PREFIX_SLOT,
            ariaLabel: replacePlaceholders(
              Constants.CLOSE_CHIP_FILTER_ARIA_LABEL,
              {
                content: this.componentObject.label,
              },
            ),
            analytics: {
              dataMetricsClickable: 'true',
              dataMetricsType: Constants.BUTTON_TYPE,
              dataMetricsLinkText: replacePlaceholders(
                Constants.CLOSE_CHIP_FILTER_ARIA_LABEL,
                {
                  content: this.componentObject.label,
                },
              ),
            },
          })}
        </beacon-button>
      </div>
    `;
  }

  render() {
    if (!this.componentObject) {
      return html``;
    }
    return this.renderComponent();
  }
}
